module.exports = __webpack_public_path__ + "static/media/docker.4c5ed894.png";